import React from 'react';
import TemplateWithTitle from 'pages/Template/TemplateWithTitle';
import {
  LABEL_MOVECLEANING_PROFILE_REGISTER,
  PAGE_SERVICE_MOVECLEANING_PROFILE_REGISTER_TITLE,
} from 'commons/ZimssaString';

interface Props {
  children: React.ReactNode;
}

function Template({ children }: Props): React.ReactElement {
  return (
    <TemplateWithTitle
      isBackBtn={true}
      title={PAGE_SERVICE_MOVECLEANING_PROFILE_REGISTER_TITLE}
      step={{
        lastStep: 2,
        currentStep: 2,
        currentStepName: LABEL_MOVECLEANING_PROFILE_REGISTER,
      }}
    >
      {children}
    </TemplateWithTitle>
  );
}

export default Template;
